import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { useExerciseSession } from "../../ExerciseSessionProvider";
import { pages } from "../../pages/pages";
import { ExerciseInSession } from "../../types";
import { convertSessionToDbSession } from "../../utils/session";

export function useExerciseSessionWrapper() {
    const { finishSession, ...rest } = useExerciseSession();
    const navigate = useNavigate();

    const finishSessionAndNavigateToSummary = useCallback(
        async (lastExercise: ExerciseInSession | undefined) => {
            const exercises = await finishSession(lastExercise);
            const session = convertSessionToDbSession({ exercises });
            navigate(pages.summary, { state: { session } });
        },
        [finishSession, navigate],
    );

    const value = useMemo(
        () => ({
            ...rest,
            finishSessionAndNavigateToSummary,
        }),
        [finishSessionAndNavigateToSummary, rest],
    );

    return value;
}
